import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetOperationHistoryResponse } from '@/api/handlers/resources/operations/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { OperationsQueryKeys } from './operationsQueryKeys';

const STALE_TIME_MS = 60_000;

/**
 * One template's configuration history.
 *
 * Takes no `locale`, like the catalog and unlike the activity drawer: the names
 * on this response are the operation's own, carried in both locales, and the
 * account ids on the version lines are resolved against the chart the client
 * already holds. So a language switch re-renders rather than refetching.
 *
 * `enabled` is the caller's, the pattern every accounting query here follows.
 */
export const useOperationHistoryQuery = (key: string, enabled: boolean) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetOperationHistoryResponse>>({
        queryKey: OperationsQueryKeys.history(key),
        queryFn: () => apiClient.operations.getHistory(key),
        enabled: enabled && key.length > 0,
        staleTime: STALE_TIME_MS,
    });
};
